import ArcIcon from './ArcIcon.js';
customElements.define('arc-icon', ArcIcon);
